module.exports = __webpack_public_path__ + "static/LATERAL-c71e63aa1beb4785c2de044555c82919.webp";